<!--
 * @Author: 郭德纲
 * @Date: 2021-11-20 15:46:49
 * @LastEditTime: 2021-11-25 21:45:32
 * @LastEditors: 郭德纲
 * @Description: 
-->
<template>
  <div class="Discoverstore-main">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
export default {
  name: 'Discoverstore',
  components: {},
}
</script>

<style>
.Discoverstore-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 450px;
  margin: auto;
}
</style>